<template>
	<div>
		<div class="dropzone container" v-if="isImpl && step === 0">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="reuploadVl1"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг 1</p>
				Остатки востребованных ТМЗ за предыдущие финансовые годы
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading & (uploadProgress < 100)" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
			<div
				v-if="uploading & (uploadProgress == 100)"
				class="loading-status"
			>
				Документ загружен, идет обработка...
				<div class="spinner">
					<div id="dot1" class="dot"></div>
					<div id="dot2" class="dot"></div>
					<div id="dot3" class="dot"></div>
					<div id="dot4" class="dot"></div>
					<div id="dot5" class="dot"></div>
				</div>
			</div>
		</div>
		<!-- Upload VL 2 -->
		<div class="dropzone container" v-if="isImpl && step === 1">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="uploadVl2"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг {{ step + 1 }}</p>
				Загрузить востребованные ТМЗ за текущий отчетный период
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
		</div>

		<!-- Upload NVL 1 -->
		<div class="dropzone container" v-if="isImpl && step === 2">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="uploadNvl1"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг {{ step + 1 }}</p>
				Загрузить остатки невостребованных ликвидных ТМЗ за предыдущие
				финансовые годы
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
			<div class="skip-btn" @click="skipNvl1" role="button">
				Пропустить
			</div>
		</div>

		<!-- Upload NVL 2 -->
		<div class="dropzone container" v-if="isImpl && step === 3">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="uploadNvl2"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг {{ step + 1 }}</p>
				Загрузить невостребованные ликвидные ТМЗ за текущий отчетный
				период
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
			<div class="skip-btn" @click="skipNvl2" role="button">
				Пропустить
			</div>
		</div>

		<!-- Upload LIQ 1 -->
		<div class="dropzone container" v-if="isImpl && step === 4">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="uploadLiq1"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг {{ step + 1 }}</p>
				Загрузить остатки неликвидных ТМЗ за предыдущие финансовые годы
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
			<div class="skip-btn" @click="skipLiq1" role="button">
				Пропустить
			</div>
		</div>

		<!-- Upload LIQ 2 -->
		<div class="dropzone container" v-if="isImpl && step === 5">
			<input
				type="file"
				class="input-field"
				ref="file"
				@change="uploadLiq2"
			/>
			<div v-if="!uploading" class="call-to-action">
				<p class="step-number">Шаг {{ step + 1 }}</p>
				Загрузить неликвидные ТМЗ за текущий отчетный период
				<div role="button">Выбрать файл с компьютера</div>
			</div>
			<div v-if="uploading" class="progress-bar">
				<progress class="progress" :value="uploadProgress" max="100">
					{{ uploadProgress }} %
				</progress>
			</div>
			<div class="skip-btn" @click="skipLiq2" role="button">
				Пропустить
			</div>
		</div>

		<modal name="file-modal">
			<div class="modal-inner">
				<div>
					Следует загружать следующие типы файлов: xlsx, xls
				</div>
				<button @click="closeModal">Понятно</button>
			</div>
		</modal>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
	name: 'ImportFile',
	// props: ['isImpl, step'],
	props: {
		isImpl: {
			type: Boolean,
			required: true,
		},
		step: {
			required: true,
		},
		id: {
			required: true,
		},
	},
	data() {
		return {
			uploading: false,
			progress: 0,
			// step: this.step,
			// isImpl: this.isImpl
		};
	},
	methods: {
		skipVl1() {
			this.$store.dispatch('skipVl1');
		},
		async reuploadVl1() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('tmz_id', this.id);

			console.log(formData);

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					this.uploading = true;
					this.$store.dispatch('reuploadVl1', formData);
				} catch (e) {
					console.log(e);
				}
			}
		},
		async uploadVl2() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('type', 'liquid');
			formData.append('tmz_id', this.id);

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					this.uploading = true;
					this.$store.dispatch('uploadVl2', formData);
				} catch (e) {
					console.log(e);
				}
			}
		},
		skipNvl1() {
			const formData = new FormData();
			formData.append('tmz_id', this.id);
			this.$store.dispatch('skipNvl1', formData);
		},
		skipNvl2() {
			const formData = new FormData();
			formData.append('tmz_id', this.id);
			this.$store.dispatch('skipNvl2', formData);
		},
		async uploadNvl1() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('tmz_id', this.id);

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					this.uploading = true;
					this.$store.dispatch('uploadNvl1', formData);
				} catch (e) {
					console.log(e);
				}
			}
		},
		async uploadNvl2() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('tmz_id', this.id);

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					this.uploading = true;
					this.$store.dispatch('uploadNvl2', formData);
				} catch (e) {
					console.log(e);
				}
			}
		},
		skipLiq1() {
			const formData = new FormData();
			formData.append('tmz_id', this.id);
			this.$store.dispatch('skipLiq1', formData);
		},
		skipLiq2() {
			const formData = new FormData();
			formData.append('tmz_id', this.id);
			this.$store.dispatch('skipLiq2', formData);
		},
		async uploadLiq1() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('tmz_id', this.id);

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					this.uploading = true;
					this.$store.dispatch('uploadLiq1', formData);
				} catch (e) {
					console.log(e);
				}
			}
		},
		async uploadLiq2() {
			const file = this.$refs.file.files[0];
			let fileName = document.querySelector('.input-field').value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();

			const formData = new FormData();
			formData.append('file', file);
			formData.append('type', 'liquid');
			formData.append('tmz_id', this.id);

			if (!(extFile == 'xlsx' || extFile == 'xls' || extFile == 'xlsm')) {
				this.$modal.show('file-modal');
				this.file = null;
			} else {
				try {
					this.uploading = true;
					this.$store.dispatch('uploadLiq2', formData);
				} catch (e) {
					console.log(e);
				}
			}
		},
		closeModal() {
			this.$modal.hide('file-modal');
		},
	},
	computed: {
		...mapGetters(['uploadProgress']),
	},
};
</script>

<style lang="scss" scoped>
.skip-btn {
	position: absolute;
	bottom: 20px;
	right: 20px;
	background: #36429e;
	color: white;
	padding: 1rem 2rem;
	border-radius: 25px;
}
</style>
